import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './UEEPCI.css';
import { UEEPCI as UEEPCIData } from '../../json/UEEPCI';


const UEEPCI = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      return (
        
        <div className="container UEEPCI-container container-mh">
    <div className="row">
        <div className="col-12 mb-4">
            <h3 className="title">Unidad Especializada de Ética y de Prevención de Conflictos de Interés</h3>
            <hr className="hr-gob" />
        </div>
    </div>

    <div className="row g-4 mb-5">
        {UEEPCIData.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
                <Link
                    to={item.UEEPCI_url}
                    className={`UEEPCI-card ${item.destacado ? "destacado" : ""}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {item.UEEPCI_titulo}
                </Link>
            </div>
        ))}
    </div>
</div>

        
  )
}

export default UEEPCI